import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Drawer from '@components/Drawer';
import { useTranslation } from '@hooks';
import SubscriptionCard from './SubscriptionCard';

const CustomSubscriptionDrawer = ({ title, primaryAction, actionDisabled, open, onClose }) => {
    const { t } = useTranslation();
    const [selectedSubscription, setSubscription] = useState({});

    const subscriptions = useSelector(state => state.account?.account?.subscriptions || []);

    useEffect(() => {
        if (subscriptions.length) {
            setSubscription(subscriptions[0]);
        }
    }, [subscriptions]);

    const onSubmit = async () => primaryAction(selectedSubscription.id);

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            title={title}
            primaryText={t('buttons.continue')}
            primaryDisabled={actionDisabled}
            primaryAction={onSubmit}
            secondaryText={t('buttons.cancel')}
        >
            <div style={{ display: 'grid', gridGap: '8px' }}>
                {subscriptions.length > 0 &&
                    subscriptions.map(item => (
                        <SubscriptionCard
                            key={item.id}
                            subscription={item}
                            selectedSubscription={selectedSubscription}
                            setSubscription={() => setSubscription(item)}
                        />
                    ))}
            </div>
        </Drawer>
    );
};

export default CustomSubscriptionDrawer;
